import {createTheme} from "@mui/material";

export default (prefersDarkMode, fontFamily = "IRANSans") =>
    createTheme({
        direction: "ltr",
        palette: {
            mode: prefersDarkMode ? 'dark' : 'light',
            background: {
                default: prefersDarkMode ? "#121212" : "#f2f2f2",
                paper: prefersDarkMode ? "#1e1e1e" : "#fff",
            },
            primary: {
                dark: "#096467",
                main: prefersDarkMode ? "#12BEC4" : "#0C898D",
                light: "#12BEC4"
            },
            card: {
                dark: prefersDarkMode ? "#141414" : "#fff",
                main: prefersDarkMode ? "#1e1e1e" : "#fff",
                light: prefersDarkMode ? "#282828" : "#fff",
            },
            secondary: {
                dark: "#BF9926",
                main: prefersDarkMode ? "#FFE082" : "#FFCC33",
                light: "#FFE082"
            },
            gray1: {
                main: prefersDarkMode ? "#C4C4C4" : "#3A3A3A",
            },
            gray2: {
                main: prefersDarkMode ? "#8F8F8F" : "#707070",
            },
            gray3: {
                main: prefersDarkMode ? "#1F1F1F" : "#E1E1E1",
            },
            gray4: {
                main: prefersDarkMode ? "#333333" : "#CCCCCC",
            }
        },
        shape: {
            borderRadius: 10,
            borderRadiusPx: "10px",

        },
        typography: {
            fontFamily: `${fontFamily}, Arial`
        },
        components: {
            MuiCollapse: {
                styleOverrides: {
                    wrapperInner: {
                        display: "flex"
                    }
                }
            }
        }
    })
